<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-col v-if="rol == 'root'" cols="12" xs="12" sm="12" md="4" lg="3" xl="3" class="pa-0 pl-4 mb-10">
                <v-autocomplete
                    outlined
                    dense
                    hide-details
                    :items="itemsClientes"
                    item-text="nombre"
                    item-value="id"
                    label="Cliente"
                    v-model="cliente_value"
                    no-data-text="Datos no disponibles"
                    clearable
                ></v-autocomplete>
            </v-col>
            <v-row class="pa-0 mt-0 mb-0">
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pa-0 ">
                    <div style="display: flex; width:100%; height:100%; justify-content: flex-start;">
                        <hr class="vr"/>
                        <p class="tblName pb-2">Seguridad social</p>
                    </div>
                </v-col>
                
            </v-row>

            <div class="list-grid mt-5">
                <div class="card-grid">
                    <div class="pa-6">
                        <div class="text-card-01">Registro patronales</div>
                        <div class="text-card-02">{{ general_registros_patronales }}</div>
                        <div class="text-card-03">Registrados en la cuenta</div>
                    </div>
                </div>
                <div class="card-grid">
                    <div class="pa-6">
                        <div class="text-card-01">Certificados por vencer</div>
                        <div class="text-card-02">{{ general_certificados_por_vencer }}</div>
                        <div class="text-card-03">10 días o menos vencen</div>
                    </div>
                </div>
                <div class="card-grid">
                    <div class="pa-6">
                        <div class="text-card-01">Lotes sin respuesta</div>
                        <div class="text-card-02">{{ general_lotes_sin_respuesta }}</div>
                        <div class="text-card-03">Lotes sin procesar</div>
                    </div>
                </div>
                <div class="card-grid">
                    <div class="pa-6">
                        <div class="text-card-01">Trabajadores activos</div>
                        <div class="text-card-02">{{ general_trabajadores_activos }}</div>
                        <div class="text-card-03">Registrados en la cuenta</div>
                    </div>
                </div>
            </div>

            <v-row class="pa-0 mt-0 mb-0 mt-10">
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pa-0 ">
                    <div style="display: flex; width:100%; height:100%; justify-content: flex-start;">
                        <hr class="vr"/>
                        <p class="tblName pb-2">Movimientos afiliatorios</p>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                
                <!-- Card: Anuales -->
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="mt-0">
                    <div class="card-grafica mt-0">
                        <div class="pa-5">
                            <v-row class="pa-0 ma-0 mb-3 align-center">
                                <v-col cols="12" sm="12" class="py-0 pr-3 mb-5">
                                    <div class="titulo-grafica">Anuales</div>
                                </v-col>
                                <v-col cols="12" xs="12" sm="4" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        dense
                                        hide-details
                                        :items="itemsRegistrosPatronales"
                                        item-text="nombreClave"
                                        item-value="id"
                                        label="Registro Patronal"
                                        v-model="registro_patronal_value_01"
                                        no-data-text="Datos no disponibles"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xs="12" sm="3" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        dense
                                        hide-details
                                        :items="itemsAnios"
                                        item-text="anio"
                                        item-value="valor"
                                        label="Año"
                                        v-model="anio_value"
                                        no-data-text="Datos no disponibles"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xs="12" sm="auto" class="py-0">
                                    <v-btn
                                        depressed
                                        :loading="loadingGrafica01"
                                        @click="getMovimientosAnuales"
                                        class="btn-consultar"
                                        x-small
                                    >
                                        <v-icon>arrow_forward</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-chart
                                style="width:100%; height:400px; position:relative;"
                                :options="grafica01"
                                :autoresize="true"
                            />
                        </div>
                    </div>
                </v-col>

                <!-- Card: Rangos -->
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="mt-0">
                    <div class="card-grafica mt-0">
                        <div class="pa-5">
                            <v-row class="pa-0 ma-0 mb-3 align-center">
                                <v-col cols="12" sm="12" class="py-0 pr-3 mb-5">
                                    <div class="titulo-grafica">Rangos</div>
                                </v-col>
                                <v-col cols="12" xs="12" sm="4" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        dense
                                        hide-details
                                        :items="itemsRegistrosPatronales"
                                        item-text="nombreClave"
                                        item-value="id"
                                        label="Registro Patronal"
                                        v-model="registro_patronal_value_02"
                                        no-data-text="Datos no disponibles"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xs="12" sm="3" class="py-0">
                                    <VuetifyDatePicker
                                        outlined
                                        dense
                                        hideDetails
                                        v-model="fecha_inicial_value"
                                        :valorDefecto="fecha_inicial_value"
                                        label="Fecha inicial"
                                        placeholder="dd/mm/aaaa"
                                    />
                                </v-col>
                                <v-col cols="12" xs="12" sm="3" class="py-0">
                                    <VuetifyDatePicker
                                        outlined
                                        dense
                                        hideDetails
                                        v-model="fecha_final_value"
                                        :valorDefecto="fecha_final_value"
                                        label="Fecha final"
                                        placeholder="dd/mm/aaaa"
                                    />
                                </v-col>
                                <v-col cols="12" xs="12" sm="auto" class="py-0">
                                    <v-btn
                                        depressed
                                        :loading="loadingMovimientosAfiliatorios"
                                        @click="getMovimientosAfiliatorios"
                                        class="btn-consultar"
                                        x-small
                                    >
                                        <v-icon>arrow_forward</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>


                            <div class="movimientos-afiliatorios-grid">
                                <div class="movimiento-item">
                                    <div class="movimiento-label">Altas/Reingresos</div>
                                    <div class="movimiento-value">{{ movimientos_altas }}</div>
                                    <div class="movimiento-sub">Registrados en la cuenta</div>
                                </div>
                                
                                <div class="movimiento-item">
                                    <div class="movimiento-label">Bajas</div>
                                    <div class="movimiento-value">{{ movimientos_bajas }}</div>
                                    <div class="movimiento-sub">Registrados en la cuenta</div>
                                </div>
                                <div class="movimiento-item">
                                    <div class="movimiento-label">Modificaciones</div>
                                    <div class="movimiento-value">{{ movimientos_modificaciones }}</div>
                                    <div class="movimiento-sub">Registrados en la cuenta</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>


            <v-row class="pa-0 ma-0">
                <v-col cols="12" lg="12" class="mt-5 px-0">
                    <simple-table
                        tableName="Movimientos Programados"
                        :isSelectable="false"
                        :rows="itemsTablaMovimientosProgramados"
                        :columns="columnsMovimientosProgramados"
                        :perPage="[10, 25, 50, 100]"
                        ref="tablaMovimientosProgramados"
                        :loading="loadingTablaMovimientosProgramados"
                    >   
                        
                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data" >
                                <td>
                                    <div>
                                        {{ dateFormat(item.fecha) }} 
                                    </div>
                                </td>
                                <td > 
                                    <div>
                                        {{ item.numero_lote }} 
                                    </div>
                                </td>
                                <td > 
                                    <div class="text-center">
                                        {{ item.clave == '08' ? item.total : '0' }} 
                                    </div>
                                </td>
                                <td > 
                                    <div class="text-center">
                                        {{ item.clave == '02' ? item.total : '0' }} 
                                    </div>
                                </td>
                                <td > 
                                    <div class="text-center">
                                        {{ item.clave == '07' ? item.total : '0' }} 
                                    </div>
                                </td>
                                
                            </tr>
                        </tbody>
                    </simple-table>
                </v-col>
            </v-row>


            <v-row class="pa-0 ma-0">
                <v-col cols="12" lg="12" class="mt-5 px-0">
                    <simple-table
                        tableName="Firmas Expiradas"
                        :isSelectable="false"
                        :rows="itemsTablaFirmasExpiradas"
                        :columns="columnsFirmasExpiradas"
                        :perPage="[10, 25, 50, 100]"
                        ref="tablaFirmasExpiradas"
                        :loading="loadingTablaFirmasExpiradas"
                    >   
                        
                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data" >
                                <td>
                                    <div>
                                        {{ item.registro_patronal }} 
                                    </div>
                                </td>
                                <td > 
                                    <div>
                                        {{ item.nombre }} 
                                    </div>
                                </td>
                                <td > 
                                    <div>
                                        {{ item.inicio_vigencia }} 
                                    </div>
                                </td>
                                <td > 
                                    <div>
                                        {{ item.fecha_vencimiento }} 
                                    </div>
                                </td>
                                <td > 
                                    <div>
                                        {{ item.tipo_certificado }} 
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </simple-table>
                </v-col>
            </v-row>

            <div class="mb-15"></div>



































            

        </v-container>
    </div>
</template>


<script>
import BtnAcciones from '@/components/BtnAcciones.vue';
import DatatableSimple from '@/components/simpletableCheckbox/Datatable.vue';
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
import apiSeguridadSocial from "@/api/nominas/seguridadSocial";
import apiClientes from "@/api/clientes";
import Notify from '@/plugins/notify';

export default {
    components: {
        "simple-table": DatatableSimple,
        BtnAcciones,
        VuetifyDatePicker,
    },
    data() {
        return {
            url         : "imss-moviento-programados",
            urlFirmas   : "imss-moviento-programados",
            columnsMovimientosProgramados: [
                {
                    label: 'Fecha de envío',
                    name: 'fecha',
                    filterable: false,
                },
                {
                    label: 'Lote',
                    name: 'numero_lote',
                    filterable: false
                },
                {
                    label: 'Reingresos',
                    name: 'reingresos',
                    filterable: false,
                    align: 'center',
                },
                {
                    label: 'Bajas',
                    name: 'bajas',
                    filterable: false,
                    align: 'center',
                },
                {
                    label: 'Modificaciones',
                    name: 'modificaciones',
                    filterable: false,
                    align: 'center',
                },
            ],
            filters     : {
                activo    :true,
                paginate  :true,
                order     :"asc"
            },
            columnsFirmasExpiradas: [
                {
                    label: 'Registro Patronal',
                    name: 'registro_patronal',
                    filterable: false
                },
                {
                    label: 'Razón social',
                    name: 'nombre',
                    filterable: false
                },
                {
                    label: 'Inicio de vigencia',
                    name: 'inicio_vigencia',
                    filterable: false
                },
                {
                    label: 'Fecha de vencimiento',
                    name: 'fecha_vencimiento',
                    filterable: false
                },
                {
                    label: 'Tipo de certificado',
                    name: 'tipo_certificado',
                    filterable: false
                },
            ],
            filters_firmas: {
                activo    :true,
                paginate  :true,
                order     :"asc"
            },
            userData        : this.$session.get('usuario'),
            accion          : null,
            tituloModal     : null,
            imagen          : "",
            dialog          : false,
            rol             : null,
            isLoading       : false,
            isSaving        : false,
            cliente_value   : null,
            itemsRegistrosPatronales: [],
            registro_patronal_value_01: null,
            registro_patronal_value_02: null,
            itemsAnios: [],
            anio_value: null,
            fecha_inicial_value: null,
            fecha_final_value: null,
            loadingGrafica01: false,
            loadingMovimientosAfiliatorios: false,
            general_registros_patronales: 0,
            general_certificados_por_vencer: 0,
            general_lotes_sin_respuesta: 0,
            general_trabajadores_activos: 0,
            movimientos_altas: 0,
            movimientos_bajas: 0,
            movimientos_modificaciones: 0,

            itemsTablaMovimientosProgramados: [],
            loadingTablaMovimientosProgramados: false,

            itemsTablaFirmasExpiradas: [],
            loadingTablaFirmasExpiradas: false,

            itemsClientes: [],


            grafica01: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    icon    : "circle",
                    orient  : "horizontal",
                    type    : "scroll",
                    y       : "bottom",
                    text    : "top",
                    padding : 0,
                    textStyle: {
                        fontSize    : 12,
                        fontWeight  : 500,
                        fontFamily  : "Montserrat",
                        fontStyle   : "normal",
                        color       : "#96999A",
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                    //padding para que las líneas no queden pegadas a los bordes
                    axisLabel: {
                        padding: [10, 0, 10, 0],
                    },
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name:'Altas/Reingresos',
                        type:'line',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        lineStyle: {
                            normal: {
                                width: 2,
                                color: {
                                    type: 'linear',
                
                                    colorStops: [{
                                        offset: 0,
                                        color: '#219653'
                                    }, {
                                        offset: 1,
                                        color: '#219653'
                                    }],
                                },
                            }
                        },
                        itemStyle: {
                                normal: {
                                color: '#219653',
                                borderWidth: 10,
                                borderColor: "#219653"
                            }
                        },
                    },

                    {
                        name:'Modificaciones',
                        type:'line',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        lineStyle: {
                            normal: {
                                width: 2,
                                color: {
                                    type: 'linear',
                
                                    colorStops: [{
                                        offset: 0,
                                        color: '#F2C94C'
                                    }, {
                                        offset: 1,
                                        color: '#F2C94C'
                                    }],
                                },
                            }
                        },
                        itemStyle: {
                                normal: {
                                color: '#F2C94C',
                                borderWidth: 10,
                                borderColor: "#F2C94C"
                            }
                        },
                    },
                    
                    {
                        name:'Bajas',
                        type:'line',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        lineStyle: {
                            normal: {
                                width: 2,
                                color: {
                                    type: 'linear',
                
                                    colorStops: [{
                                        offset: 0,
                                        color: '#EB5757'
                                    }, {
                                        offset: 1,
                                        color: '#EB5757'
                                    }],
                                },
                            }
                        },
                        itemStyle: {
                                normal: {
                                color: '#EB5757',
                                borderWidth: 10,
                                borderColor: "#EB5757"
                            }
                        },
                    },

                ]
            }, // Fin grafica 01



        }
    },
    methods: {
        getDashboard() {
            this.isLoading = true;
            let parametros = {
                cliente_id: this.cliente_value,
            }
            apiSeguridadSocial.getDashboard(parametros).then((response) => {
                this.general_registros_patronales = response.data.registros_patronales.length;
                this.general_certificados_por_vencer = response.data.certificados_por_vencer.length;
                this.general_lotes_sin_respuesta = response.data.lotes_sin_respuesta;
                this.general_trabajadores_activos = response.data.trabajadores_activos;
                this.itemsTablaFirmasExpiradas = response.data.certificados_expirados;
                this.itemsTablaMovimientosProgramados = response.data.movimientos_programados;
                this.movimientos_altas = response.data.movimientos.altas;
                this.movimientos_bajas = response.data.movimientos.bajas;
                this.movimientos_modificaciones = response.data.movimientos.modificaciones;
                this.itemsRegistrosPatronales = response.data.registros_patronales.map((item) => {
                    return {
                        id: item.id,
                        nombreClave: item.registro_patronal + " - " + item.clave,
                    }
                });
                if (response.data.movimientos_anules) {
                    this.updateChartData(response.data.movimientos_anules);
                }
                this.isLoading = false;
            }).catch((error) => {
                Notify.error("Error al cargar el dashboard");
                this.isLoading = false;
            });
        },

        getMovimientosAnuales() {
            this.loadingGrafica01 = true;
            let parametros = {
                cliente_id: this.cliente_value,
                registro_patronal_id: this.registro_patronal_value_01,
                anio: this.anio_value,
            };
            apiSeguridadSocial.getDashboard(parametros).then((response) => {
                if (response.data.movimientos_anules) {
                    this.updateChartData(response.data.movimientos_anules);
                }
                this.loadingGrafica01 = false;
            }).catch(() => {
                Notify.error("Error al cargar los movimientos anuales");
                this.loadingGrafica01 = false;
            });
        },

        getMovimientosAfiliatorios() {
            this.loadingMovimientosAfiliatorios = true;
            let parametros = {
                cliente_id: this.cliente_value,
                registro_patronal_id: this.registro_patronal_value_02,
                fecha_inicial: this.fecha_inicial_value,
                fecha_final: this.fecha_final_value,
            };
            apiSeguridadSocial.getDashboard(parametros).then((response) => {
                this.movimientos_altas = response.data.movimientos.altas;
                this.movimientos_bajas = response.data.movimientos.bajas;
                this.movimientos_modificaciones = response.data.movimientos.modificaciones;
                this.loadingMovimientosAfiliatorios = false;
            }).catch(() => {
                Notify.error("Error al cargar los movimientos afiliatorios");
                this.loadingMovimientosAfiliatorios = false;
            });
        },

        updateChartData(movAnuales) {
            this.grafica01 = {
                ...this.grafica01,
                series: [
                    { ...this.grafica01.series[0], name: 'Altas', data: movAnuales.map(m => m.altas) },
                    { ...this.grafica01.series[1], data: movAnuales.map(m => m.modificaciones) },
                    { ...this.grafica01.series[2], data: movAnuales.map(m => m.bajas) },
                ]
            };
        },

        getClientes() {
            let params = {
                activo      : true,
                paginate    : false,
            };

            apiClientes.getClientes(params)
            .then(response => {
                this.itemsClientes = response.data;
            })
            .catch(error => {
                console.error(error);
            });
        },
        dateFormat(fecha, tipo) {
            if(fecha == null){
                return;
            }
            let fecha2 = fecha.split("-");
            if(tipo == 'tabla'){
                return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
            }
            else{
                return fecha2[2] + "/" + fecha2[1]+ "/" + fecha2[0];
            }
            
        },

    },

    created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;
        const hoy = new Date();
        const anioActual = hoy.getFullYear();
        const mesActual = hoy.getMonth();
        const primerDia = new Date(anioActual, mesActual, 1);
        const ultimoDia = new Date(anioActual, mesActual + 1, 0);
        const pad = (n) => String(n).padStart(2, '0');
        this.fecha_inicial_value = `${primerDia.getFullYear()}-${pad(primerDia.getMonth() + 1)}-${pad(primerDia.getDate())}`;
        this.fecha_final_value   = `${ultimoDia.getFullYear()}-${pad(ultimoDia.getMonth() + 1)}-${pad(ultimoDia.getDate())}`;
        this.itemsAnios = Array.from({ length: 5 }, (_, i) => {
            const anio = anioActual - i;
            return { anio: String(anio), valor: anio };
        });
        this.anio_value = anioActual;

        if(this.rol == 'root') {
            this.getClientes();
        }
        else {
            this.cliente_value = this.datosLogin.cliente_id
            this.getDashboard();
        }
        
    },
    
    watch: {
        cliente_value(val) {
            if (this.rol == 'root') {
                if (val) {
                    this.getDashboard();
                } else {
                    this.general_registros_patronales = 0;
                    this.general_certificados_por_vencer = 0;
                    this.general_lotes_sin_respuesta = 0;
                    this.general_trabajadores_activos = 0;
                    this.movimientos_altas = 0;
                    this.movimientos_bajas = 0;
                    this.movimientos_modificaciones = 0;
                    this.itemsTablaMovimientosProgramados = [];
                    this.itemsTablaFirmasExpiradas = [];
                    this.itemsRegistrosPatronales = [];
                }
            }
        }
    },
    mounted(){

    },
    updated(){
    }
}
</script>

<style scoped>
    .list-grid {
        display: grid;
        height: 125px;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
    }

    .list-grid > div {
        background-color: #FCFCFC;
        border-radius: 12px;
    }

    .text-card-01 {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #4F4F4F;
    }

    .text-card-02 {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 32px;
        line-height: 39px;
        text-align: left;
        color: #4F4F4F;
    }

    .text-card-03 {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 12px;
        text-align: left;
        color: #828282;
    }

    .card-grafica {
        background-color: #FFFFFF;
        border-radius: 12px;
    }

    .titulo-grafica {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 21px;
        text-align: left;
        color: #444975;
    }

    .btn-consultar {
        background-color: #F9F9F9;
        color: #ABABAB;
        height: 38px !important;
        width: 38px !important;
    }

    .movimientos-afiliatorios-grid {
        display: flex;
        align-items: stretch;
        justify-content: space-around;
        padding: 8px 0;
        gap: 8px;
    }

    .movimiento-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 12px 20px;
    }

    .movimiento-label {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #4F4F4F;
        margin-bottom: 4px;
    }

    .movimiento-value {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 32px;
        line-height: 39px;
        color: #4F4F4F;
        margin-bottom: 4px;
    }

    .movimiento-sub {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 12px;
        color: #828282;
    }

</style>